import { useEffect, useState, type ComponentProps } from "react"
import { Button, type ButtonProps } from "antd"
import { ScissorOutlined } from "@ant-design/icons"
import { VideoClipModal } from "~/components/VideoClipModal"

type VideoClipButtonProps = Omit<
  ComponentProps<typeof VideoClipModal>,
  "duration" | "open" | "onCancel"
> &
  Pick<ButtonProps, "className" | "size" | "disabled" | "onClick"> & {
    duration?: number
  }

export const VideoClipButton = ({
  className,
  size,
  disabled,
  onClick,
  duration,
  videoUrl,
  onConfirm,
  ...props
}: VideoClipButtonProps) => {
  const [open, setOpen] = useState(false)
  const ready =
    Boolean(videoUrl) &&
    duration !== undefined &&
    Number.isFinite(duration) &&
    duration > 0

  useEffect(() => {
    setOpen(false)
  }, [videoUrl])

  return (
    <>
      <Button
        className={className}
        size={size}
        color="primary"
        variant="outlined"
        disabled={disabled || !ready}
        icon={<ScissorOutlined />}
        onClick={(event) => {
          onClick?.(event)
          setOpen(true)
        }}
      >
        截取视频片段
      </Button>
      {ready ? (
        <VideoClipModal
          {...props}
          duration={duration}
          videoUrl={videoUrl}
          open={open && !disabled}
          onCancel={() => setOpen(false)}
          onConfirm={(start, end) => {
            onConfirm(start, end)
            setOpen(false)
          }}
        />
      ) : null}
    </>
  )
}
